import { get } from 'lodash';

import { AppState } from 'Interfaces/Interfaces';

const root = (state: AppState) => get(state, 'headerState');

export const getMenuVisible = (state: AppState) => get(root(state), 'menuVisible', false);
